"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameVars_1 = require("./../GameVars");
var GameConstants_1 = require("./../GameConstants");
var TutorialInfo = /** @class */ (function (_super) {
    __extends(TutorialInfo, _super);
    function TutorialInfo(game, index) {
        var _this = _super.call(this, game, null, "tutorial-info") || this;
        _this.x = GameConstants_1.GameConstants.GAME_WIDTH / 2;
        _this.y = GameConstants_1.GameConstants.GAME_HEIGHT / 2;
        _this.scale.y = GameVars_1.GameVars.scaleY;
        var textBack = new Phaser.Image(_this.game, 0, -300, "texture_atlas_1", "points_moves_bar");
        textBack.anchor.set(.5);
        textBack.scale.y = 1.5;
        _this.add(textBack);
        _this.text = new Phaser.Text(_this.game, 0, -300, "", { font: "25px Futura", fill: "#ffffff", align: "center" });
        _this.text.setShadow(3, 3, "rgba(0,0,0,0.5)", 3);
        _this.text.lineSpacing = -5;
        _this.text.anchor.set(.5);
        _this.add(_this.text);
        switch (index) {
            case 0:
                _this.showTutorial1();
                break;
            case 1:
                _this.showTutorial2();
                break;
            case 2:
                _this.showTutorial3();
                break;
            case 3:
                _this.showTutorial4();
                break;
            case 4:
                _this.showTutorial5();
                break;
            default:
                break;
        }
        return _this;
    }
    TutorialInfo.prototype.showTutorial1 = function () {
        var image = new Phaser.Image(this.game, 0, 0, "tut_1");
        image.anchor.set(.5);
        this.add(image);
        this.text.text = "Fill these four sections with cards from\nAce to King of each suit";
        // hand
        var card = new Phaser.Image(this.game, 195, 148, "texture_atlas_2", "2-2.png");
        card.anchor.set(.5);
        card.scale.set(.8);
        this.add(card);
        var hand = new Phaser.Image(this.game, 0, 400, "texture_atlas_1", "hand_tutorial");
        hand.anchor.set(.5);
        hand.alpha = 0;
        this.add(hand);
        this.game.add.tween(hand)
            .to({ alpha: 1 }, 250, Phaser.Easing.Cubic.Out, true, 1000);
        this.game.add.tween(hand)
            .to({ x: 195, y: 200 }, 2000, Phaser.Easing.Cubic.Out, true, 1000)
            .onComplete.add(function () {
            hand.visible = false;
        }, this);
        this.game.add.tween(card)
            .to({ x: -152, y: -150 }, 1500, Phaser.Easing.Cubic.Out, true, 3000);
    };
    TutorialInfo.prototype.showTutorial2 = function () {
        var image = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "tut_2");
        image.anchor.set(.5);
        this.add(image);
        this.text.text = "In this section arrange the cards from\nKing to Ace in alternating colors";
    };
    TutorialInfo.prototype.showTutorial3 = function () {
        var image = new Phaser.Image(this.game, 0, 0, "tut_3");
        image.anchor.set(.5);
        this.add(image);
        this.text.text = "Tap on closed Deck\nto get the required card";
        var card = new Phaser.Image(this.game, 261, -163, "texture_atlas_2", "card-back.png");
        card.anchor.set(.5);
        card.scale.set(.8);
        this.add(card);
        var hand = new Phaser.Image(this.game, 261, 100, "texture_atlas_1", "hand_tutorial");
        hand.anchor.set(.5);
        hand.alpha = 0;
        this.add(hand);
        this.game.add.tween(hand)
            .to({ alpha: 1 }, 250, Phaser.Easing.Cubic.Out, true, 1000);
        this.game.add.tween(hand)
            .to({ y: -100 }, 2000, Phaser.Easing.Cubic.Out, true, 1000)
            .onComplete.add(function () {
            hand.visible = false;
        }, this);
        this.game.add.tween(card)
            .to({ x: 170 }, 500, Phaser.Easing.Cubic.Out, true, 3000);
        this.game.add.tween(card.scale)
            .to({ x: 0 }, 250, Phaser.Easing.Cubic.Out, true, 3000)
            .onComplete.add(function () {
            card.frameName = "3-2.png";
            if (!this.game) {
                return;
            }
            this.game.add.tween(card.scale)
                .to({ x: .8 }, 250, Phaser.Easing.Cubic.Out, true);
        }, this);
    };
    TutorialInfo.prototype.showTutorial4 = function () {
        var image = new Phaser.Image(this.game, 0, -75, "texture_atlas_1", "tut_4-player1");
        image.anchor.set(.5);
        this.add(image);
        image = new Phaser.Image(this.game, 0, 290, "texture_atlas_1", "tut_4-player2");
        image.anchor.set(.5);
        this.add(image);
        this.text.text = "Each game is 5 min\nFinish early to get Time Bonus";
    };
    TutorialInfo.prototype.showTutorial5 = function () {
        var image = new Phaser.Image(this.game, 0, 0, "tut_5");
        image.anchor.set(.5);
        this.add(image);
        this.text.text = "All players in a contest\nget the same cards";
    };
    return TutorialInfo;
}(Phaser.Group));
exports.TutorialInfo = TutorialInfo;
